/** Propuesta 2 — Rolda con En Producción con MEM (sin paquete TNO). */

export const ROLDA_MEM_ONLY_PROPOSAL = {
  eyebrow: 'Propuesta focalizada',
  title: 'Rolda × En Producción con MEM',
  concept: 'El Momento Rolda',
  tagline:
    'Endoso directo en el programa; logo de Rolda de forma permanente en el mini site En Producción con MEM en TNO Network. Sin rotativa ni otros inventarios web TNO fuera de ese espacio.',
  intro:
    'Aprovechamos la energía de María Eugenia Moreno para mostrar que Rolda es el aliado de quien está «en la calle produciendo»: autoridad, producto en mano y consejos de estilo en el mismo tono del programa.',
  budgetLabel: 'Presupuesto mensual',
  budgetAmount: '$100',
  programLabel: 'Programa',
  programName: 'En Producción con MEM',
  focusLabel: 'Enfoque',
  focusText: 'Endoso en el programa y marca fija en el mini site en TNO Network.',
  deliverables: [
    {
      title: 'Mención de autoridad (live placement)',
      body:
        'Mem no solo menciona la marca: tiene el producto en su escritorio o set. «Para estar en producción, hay que verse bien. Yo uso Rolda para mantener el estilo todo el día».',
    },
    {
      title: 'Sección «El tip de estilo de Mem»',
      body:
        'Un segmento de unos 30 segundos dentro del programa con un consejo rápido de imagen personal usando un producto concreto (cera, gel, after shave).',
    },
    {
      title: 'Cintillo visual',
      body:
        'Presencia del logo de Rolda con un QR hacia su catálogo o Instagram durante las menciones de Mem, para cerrar el circuito de descubrimiento.',
    },
    {
      title: 'Logo en el mini site En Producción con MEM',
      body:
        'El logo de Rolda queda incorporado de forma permanente al mini site del programa en TNO Network (rutas dedicadas bajo En Producción con MEM), como presencia estable de la marca en ese entorno.',
    },
  ],
  whyTitle: 'Por qué ser creativos con Rolda',
  whyPoints: [
    {
      title: 'Del gel al lifestyle',
      body:
        'Posicionar a Rolda como marca de cuidado integral — skincare, barbería y styling — y no solo como «el gel de siempre».',
    },
    {
      title: 'Confianza en la conversación',
      body:
        'El formato del programa permite explicar uso real y beneficios sin la rigidez del spot clásico: cercanía que refuerza credibilidad.',
    },
    {
      title: 'Cercanía que vende',
      body:
        'El tono del set y la conversación en vivo generan identificación con la audiencia; encaja con marcas que quieren sonar humanas, no solo anunciadas.',
    },
  ],
};
